import React from 'react';
import { motion } from 'framer-motion';
interface ResumeSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function ResumeSection({
  title,
  children,
  className = '',
  delay = 0
}: ResumeSectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={`mb-12 print:mb-8 ${className}`} data-id="element-64">
      <h2 className="text-xs font-bold tracking-[0.2em] uppercase text-slate-400 mb-6 border-b border-slate-200 pb-2 print:text-black print:border-black" data-id="element-65">
        {title}
      </h2>
      <div className="pl-0 md:pl-4 print:pl-0" data-id="element-66">{children}</div>
    </motion.section>;
}